console.log("process.env.NODE_ENV", process.env.NODE_ENV);
module.exports = {
    'appName': 'PMB DB',
    'versi': '0.2.1 Beta',
    'apiUrl': (process.env.NODE_ENV === 'development') ? (`${window.location.protocol}//${window.location.hostname}:1083`) : (`https://do-event.xyz/pmb-db-api`),
    // 'apiUrl': `https://do-event.xyz/pmb-db-api`,
    // 'apiUrl': `http://lokal.com:1083`,
    'perpage': 30,
    'key': `fac6bf92dd997c72f16ad1b6bffa9bef`,
    'progam': '001'
};